import script from "./QuestionFormForm.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionFormForm.vue?vue&type=script&setup=true&lang=js"

import "./QuestionFormForm.vue?vue&type=style&index=0&id=0990037b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0990037b"]])

export default __exports__